<template lang="pug">
.perf-wrap
  .perf
    .perf-chart-wrap
      .perf-items
        .title performance
        //-.sector(v-for="(percent, sector) in Object.keys(scenes)")
          span.percent {{ percent }}%&nbsp;
          | &mdash; {{ sector }}
      keep-alive
        canvas.perf-chart(ref="sectors", width="200", height="100")
      .legend
        .axis-description percentage of holdings
        vc-donut(:sections="[{ value: 1, label: 'leaders', color: 'orange' }, { value: 1, label: 'laggards', color: brn + '77' }, { value: 1, label: 'loss', color: brn }]",
          :thickness="15",
          :size="150",
          has-legend,
          legend-placement="bottom",
          foreground="#f6f6f6")
</template>
<script>
import { Chart, PolarAreaController, RadialLinearScale, ArcElement, Legend, Tooltip } from 'chart.js';
// import { Chart, PieController, ArcElement, Legend, Tooltip } from 'chart.js';
import 'chartjs-adapter-moment';
//import ohlc from './ohlc';
import { mapGetters, mapActions } from 'vuex';
let ohlc;
export default {
  name: 'perf',
  computed: {
    ...mapGetters(['engage', 'engageSection', 'publishers']),
    brn: () => '#8D6E4F',
    scenes() {
      return this.engage?.scenes;
    }
  },
  methods: {
    ...mapActions(['loadEngageRoboReport', 'toggleEngageSelectedDocument', 'toggleEngageSelectedPublisher', 'toggleSelectedWatchlistDocType', 'toggleEngageSelectedTheme']),
    adjustPercent(raw, round = true) {
      const { totalEquitiesHoldingsPercentage: tehp } = this.engage?.fund?.summary || {};
      const value = (tehp / 100) * raw;
      return round ? Math.round(raw) : raw;
      //return round ? Math.round(value) : value;
    }
  },
  // components: { viewer: () => import('@/components/topo-components/viewer'), reportCard, reportOpener, clipboard, highlighter } //,
  // components: { ohlc },
  async mounted() {
    const { scenes, brn, publishers, engage, adjustPercent } = this;
    //console.log('perf mounted', stats, this.engage);
    /*
    --sectorPercentages

    regionPercentages
    collatedRegionPercentages

    --stylePercentages
    --collatedStylePercentages

    collatedCapPercentages

    --paysDividendPercentages
    --isNewPercentages
    --minPercentage
    --maxPercentage
    --averagePercentage
    --medianPercentage
    minPercentageTickers
    maxPercentageTickers
    */
    //const {
      //sectorPercentages: sectors//,
      // regionPercentages: regions,
      // collatedRegionPercentages: regionsCollated,
      // stylePercentages: styles,
      // collatedStylePercentages: stylesCollated,
      // collatedCapPercentages: capsCollated
    //} = stats;
    const ctx = this.$refs.sectors.getContext('2d');
    Chart.register(PolarAreaController, RadialLinearScale, ArcElement, ArcElement, Legend, Tooltip);
    // Chart.register(PieController, ArcElement, Legend, Tooltip);
    // const brn = '#8D6E4F';
    const percent = scene => adjustPercent(scene?.stockMetadata?.fundHoldingInfo?.percentage || 0, false);
    const perf = (scene, duration = 'threeMonthsGrowthRate') => scene?.stockMetadata?.historicalPerformanceSummary?.[duration] || 0;
    const filteredAndSortedByPerf = Object.entries(scenes)
      .filter(([k, v]) => publishers[k] && percent(v) > 1)
      .sort(([_, a], [__, b]) => {
        return perf(b) - perf(a);
        // return percent(b) - percent(a);
      });
    const length = filteredAndSortedByPerf.length;
    //console.log('data', JSON.stringify(filteredAndSortedByPerf.map(([label, v]) => percent(v).toFixed(2))));
    new Chart(ctx, {
      type: 'polarArea',
      data: {
        //labels: filteredAndSortedByPerf.map(([k]) => publishers[k]?.n),
        labels: filteredAndSortedByPerf.map(([k]) => k),
        datasets: [
          {
            label: 'stocks',
            data: filteredAndSortedByPerf.map(([label, v]) => percent(v).toFixed(2)),
            // arcBackgroundColor: brn + '77',
            arcBackgroundColor: filteredAndSortedByPerf.map(
              ([_, v], i) =>
                //console.log('perf v?', v) ||
                (perf(v) < 0 && brn) ||
                (i < length / 3 && 'orange') ||
                (i > length - length / 3 && brn + '77') ||
                '#f2f2f2'
            ),
            arcHoverBorderColor: 'white',
            // circumference: 240,
            // rotation: -25,
            // cutout: '85%',
            // barThickness: 2,
            borderWidth: 1

            // borderRadius: 0.5
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
            //maxWidth: '20px',
            position: 'left',
            labels: {
              color: brn
            }
          },
          tooltip: {
            callbacks: {
              label({ label, parsed: { r: value } }) {
                // console.log('tooltipItem', tooltipItem);
                const p = perf(scenes[label]);
                const performance = p > 0 && `${ p.toFixed(1) }% increase` || `${ Math.abs(p).toFixed(1) }% loss`;
                return `${ Object.entries(engage.tickers).find(([_, t]) => t.id === label)?.[0] || publishers[label]?.n || '' }: ${ value }%  ${ performance }`;
              }
            }
          },
          NOTtooltip: {
            // Tooltip will only receive click events
            //events: ['click']
          }
        }/*,
        interaction: {
          intersect: false,
          mode: 'index'
        }*/
        /*tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let r = data.datasets[tooltipItem.datasetIndex].r || '';

              if (r) {
                r += ': ';
              }
              r += Math.round(tooltipItem.yLabel * 100) / 100;
              return r;
            }
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        }
        },*/
        /*scales: {
          // lineWidth: false,
          y: {
            beginAtZero: false,
            position: 'right',
            grid: {
              display: false,
              color: '#fafafa',
              tickColor: brn,
              drawBorder: false
            }
          },
          xAxis: {
            // The axis for this scale is determined from the first letter of the id as `'x'`
            // It is recommended to specify `position` and / or `axis` explicitly.
            type: 'time',
            grid: {
              display: false
            }
          }
        }*/
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.perf-wrap {
  &.move-left {
    & > .perf {
      left: 35rem;
    }
  }
  .perf {
    display: grid;
    grid-template-columns: 14rem;
    grid-column-gap: 3rem;
    /*position: fixed;
    top: 5rem;
    bottom: 1rem;
    //left: 21vw;
    left: 51vw;
    //width: 76vw;
    width: 46vw;*/
    position: absolute;
    top: 1.5rem;
    z-index: 1;
    left: 71rem;
    height: 19.6rem;
    //width: 19.75rem;
    background-color: rgba(white, 0.5);
    transition: background-color 250ms ease-in-out;
    &:hover {
      background-color: white;
    }
    //height: 23rem;
    //max-width: 100vw;
    //min-height: 10vh;
    //width: 100vw;
    border: 1px solid #dadada;
    border-radius: 0.5rem;
    //box-shadow: 1px 1px 3px black;
    //border-radius: 0.25rem;
    //transform: translate3d(-110vw, 0, 0);
    //transform-origin: top left;
    //transition: transform 700ms ease-in-out;
    //will-change: transform;
    //z-index: -1;
    //cursor: default;
    //transform: none;
    box-sizing: border-box;
    padding: 1rem 1rem 0.5rem;

    &.shown {
      //transform: none;
    }
    .perf-chart-wrap {
      width: 12rem;
      display: grid;
      grid-template-columns: 6rem 5rem;
      grid-column-gap: 1rem;
      .perf-items {
        & > .title {
          white-space: nowrap;
          color: $brn;
          margin-top: -1rem;
          font-size: 1.8rem;
          font-family: 'Assistant', sans-serif;
          font-weight: 200;
          text-transform: uppercase;
          padding-left: 1.5rem;
          margin-bottom: 0.5rem;
          text-align: center;
          transform: translate3d(0, 0.5rem, 0);
        }
        .perf-item {
          white-space: nowrap;
          text-align: left;
          font-size: 0.7rem;
          font-family: 'Assistant', sans-serif;
          font-weight: 200;
          text-transform: uppercase;
          & > .percent {
            display: inline-block;
            width: 1.5rem;
            font-weight: 500;
            text-align: right;
          }
        }
      }
      .perf-chart {
        width: 14rem;
        transform: translate3d(-6rem, 3rem, 0);
        transform-origin: left center;
      }
      .legend {
        .axis-description {
          position: absolute;
          top: 3.25rem;
          left: 1rem;
          right: 1rem;
          text-align: center;
          font-size: 0.7rem;
          color: $brn;
        }
        /deep/ {
          .cdc {
            opacity: 0;
            pointer-events: none;
          }
          .cdc-legend {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            transform: translate3d(4rem, -7em, 0);
            transform-origin: top right;

            .cdc-legend-item {
              font-size: 0.7rem;
              margin-bottom: 0;
            }
          }
          .cdc-text {
            text-align: left;
            text-transform: uppercase;
            font-size: 0.7rem !important;
          }
        }
      }
    }
  }
}
</style>
